import type { NavStep, NavigationType } from "../../../shared-logic/utils/Navigation";
import { NavOrigin } from "../../../shared-logic/utils/Navigation";

export const NAVIGATION_SET_STEP = "navigation/setStep" as const;
export const NAVIGATION_SET_ORIGIN = "navigation/setOrigin" as const;
export const NAVIGATION_INIT = "navigation/init" as const;

export type SetStepType = { type: typeof NAVIGATION_SET_STEP; step: NavStep; origin?: NavOrigin };
export type SetNavigationOriginType = { type: typeof NAVIGATION_SET_ORIGIN; origin: NavOrigin };

type InitNavigationType = { type: typeof NAVIGATION_INIT; navigation: NavigationType };

export const setStep = (step: NavStep, origin?: NavOrigin): SetStepType => ({
    type: NAVIGATION_SET_STEP,
    step,
    origin,
});

export const setNavigationOrigin = (origin: NavOrigin = NavOrigin.Unknown): SetNavigationOriginType => ({
    type: NAVIGATION_SET_ORIGIN,
    origin,
});

export const initNavigation = (navigation: NavigationType): InitNavigationType => ({
    type: NAVIGATION_INIT,
    navigation,
});

export type NavigationActionsType = SetStepType | SetNavigationOriginType | InitNavigationType;
